import * as types from '../constants/constants';

const initialState = {
    step: '',
    now_image: 0,
    now_level: 0,
    marker_index: 0,
    marker_activity: false,
    ifl_state: {},
    image_layout: [],
    screen_size: {},
    place_holder_layout: {},
}


const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MARKER_INDEX:
            return { ...state, marker_index: action.index };
            break;

        case types.MARKERS_ACTIVITY:
            return { ...state, marker_activity: action.bool };
            break;

        case types.LEVEL:
            return { ...state, now_level: action.level };
            break;

        case types.IMAGE:
            return { ...state, now_image: action.image };
            break;

        case types.IFL_STATE:
            return { ...state, ifl_state: action.obj };
            break;

        case types.NOW_STEP:
            return { ...state, step: action.step };
            break;
        
        case types.IMAGE_LAYOUT:
            return { ...state, image_layout: {
                ...state.image_layout,
                [action.index]: action.imageLayout,
            }};
        
        case types.SLIDER_STATE:
            return { ...state, slider_state: action.sliderState };

        case types.PLACE_HOLDER_LAYOUT:
            return { ...state, place_holder_layout: action.placeHolderLayout };

        case types.SCREEN_SIZE:
            return { ...state, screen_size: action.screenSize };
        
        default:
           return state;
    }
}

export default rootReducer;